/** Valor del campo `type` en la raíz del JSON de la encuesta */
export enum QuestionnaireTypes {
  QN = 'QN',
  TAQT = 'TAQT'
}
